import { render, staticRenderFns } from "./NotesWidget.vue?vue&type=template&id=f5cbaef8&scoped=true&"
import script from "./NotesWidget.vue?vue&type=script&lang=js&"
export * from "./NotesWidget.vue?vue&type=script&lang=js&"
import style0 from "./NotesWidget.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotesWidget.vue?vue&type=style&index=1&id=f5cbaef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cbaef8",
  null
  
)

export default component.exports